<template>
  <div class="dot-progress-module">
    <div class="line">
      <div class="dot up" :class="{'point': data.dotPos === 'up'}"></div>
      <div class="dot down" :class="{'point': data.dotPos === 'down'}"></div>
      <div class="text left" :class="data.dotPos">{{data.index}}</div>
      <div class="text right" :class="data.dotPos">{{data.name}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DotProgress',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          index: '01',
          name: '默认',
          dotPos: 'down'
        }
      }
    }
  },
  methods: {},
  data () {
    return {}
  }
}
</script>
<style lang="stylus" scoped>
.dot-progress-module
  display block
  $line-height = 98px
  $line-width = 4px
  opacity 0
  transition opacity 800ms
  &.show
    opacity 1
    transition opacity 800ms
  .line
    display block
    width $line-width
    height $line-height
    position relative
    margin auto
    background-color rgba(255, 255, 255, 0.15)
    .dot
      display block
      width $line-width
      height $line-width
      position absolute
      left 0
      background-color rgba(255, 255, 255, 0.30)
      transform translate(0, -(@width/ 2))
      border-radius 50%
      &.up
        top unit($line-height / 3, 'px')
      &.down
        top unit($line-height / 3 * 2, 'px')
      &.point
        background-color rgba(235,20,10,1)
    .text
      position absolute
      font-size 16px
      line-height @font-size
      transform translate(0, -(@line-height/ 2))
      color #fff
      width auto
      white-space nowrap
      &.left
        right 10px + $line-width
      &.right
        left 10px + $line-width
      &.up
        top unit($line-height / 3, 'px')
      &.down
        top unit($line-height / 3 * 2, 'px')
</style>



// WEBPACK FOOTER //
// src/components/DotProgress.vue